import styled from 'styled-components'
import { Input } from '../../../ui/input'
import { Button } from '../../../ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import BSTable from '../../components/BSTable'
import { Checkbox } from '../../../ui/checkbox'


const PatronCheckout = () => {


    const columns = [
        {
            title: '到期日',
            dataIndex: 'due_date',
            key: 'due_date',
        },
        {
            title: '標題',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'record 種類',
            dataIndex: 'record_type',
            key: 'record_type',
        },
        {
            title: '種類',
            dataIndex: 'item_type',
            key: 'item_type',
        },
        {
            title: 'Collection',
            dataIndex: 'collection',
            key: 'collection',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'Home Library',
            dataIndex: 'home_library',
            key: 'home_library',
        },
        {
            title: 'Check out on',
            dataIndex: 'Check_out_on',
            key: 'Check_out_on',
        },
        {
            title: 'Check out from',
            dataIndex: 'check_out_from',
            key: 'check_out_from',
        },
        {
            title: 'Call number',
            dataIndex: 'call_number',
            key: 'call_number',
        },
        {
            title: 'Copy number',
            dataIndex: 'copy_number',
            key: 'copy_number',
        },
        {
            title: 'Charge',
            dataIndex: 'charge',
            key: 'charge',
        },
        {
            title: 'Fine',
            dataIndex: 'fine',
            key: 'fine',
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Renew',
            dataIndex: 'renew',
            key: 'renew',
            render: () => (
                <Checkbox />
            )
        },
        {
            title: 'Check in',
            dataIndex: 'check_in',
            key: 'check_in',
            render: () => (
                <Checkbox />
            )
        },
    ]

    const data = [
        {
            due_date: 1,
            title: '學生',
            record_type: '學生',
            item_type: '1個月',
            collection: '一年',
            location: '6',
            home_library: '24',
            Check_out_on: '0',
            check_out_from: '0',
            call_number: '',
            copy_number: '',
            charge: '',
            fine: '',
            price: '',
            renew: '',
            check_in: '',
        },
    ]

    return (
        <MainContainer>
            <Title>Check Out</Title>
            <FlexBox>
                <WhiteBox>
                    <SubTitle>Checking out to Patron</SubTitle>
                    <FlexBox>
                        <Input />
                        <Button>Check Out</Button>
                    </FlexBox>
                </WhiteBox>
                <WhiteBox>
                    <SubTitle>Mr Ou John (9235)</SubTitle>
                    <div>主要地址</div>
                    <div>7172930</div>
                    <div>s9235@mail.nknu.edu.tw</div>
                    <div>Born: 07/08/1975 (48 years)</div>
                    <div>No city stored.</div>
                    <div>Category: 測試用群組 (TEST)</div>
                    <div>Home library: 介壽校區</div>
                    <div>Borrowernumber: 3</div>
                    <div>Updated on 05/12/2024 11:21</div>
                </WhiteBox>
                <FlexBox>
                    <Tabs defaultValue="CheckOut" className="w-full">
                        <TabsList>
                            <TabsTrigger value="CheckOut">Check Out</TabsTrigger>
                            <TabsTrigger value="Holds">Holds</TabsTrigger>
                            <TabsTrigger value="Claims">Claims</TabsTrigger>
                            <TabsTrigger value="Restrictions">Restrictions</TabsTrigger>
                            <TabsTrigger value="PatronLists">Patron Lists</TabsTrigger>
                        </TabsList>
                        <TabsContent value="CheckOut">

                            <BSTable columns={columns} demoData={data} />
                        </TabsContent>
                        <TabsContent value="Holds">Patron has nothing on hold.</TabsContent>
                        <TabsContent value="Claims"></TabsContent>
                        <TabsContent value="Restrictions">Patron is currently unrestricted.<Button >Add unrestricted</Button></TabsContent>
                        <TabsContent value="PatronLists"></TabsContent>
                    </Tabs>
                </FlexBox>
            </FlexBox>
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
width: 100%;
font-size: 1.2em;
font-weight: 600;
padding-bottom: 0.5em;
`

const FlexBox = styled.div`
display: flex;
gap: 2em;
width: 100%;
flex-wrap: wrap;
`

const WhiteBox = styled.div`
background-color: #fff;
min-width: 50%;
padding: 1em;
`

export default PatronCheckout
